import React from "react";
import "./index.scss";
import Menu from "devextreme-react/menu";
import { IMdaeMenuOption } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

const MdaeDrawer: React.FC<IMdaeMenuOption> = (props) => {
  const dispatch = useDispatch();
  return (
    <Menu
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_MENU,
          e.component,
          dispatch
        );
      }}
    >
      {props.children}
    </Menu>
  );
};
export default MdaeDrawer;
